import { render } from "./Overview.vue?vue&type=template&id=04952fb2&scoped=true"
const script = {}

import "./Overview.vue?vue&type=style&index=0&id=04952fb2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04952fb2"],['__file',"src/views/jbh/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04952fb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04952fb2', __exports__)) {
    console.log('reload')
    api.reload('04952fb2', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=04952fb2&scoped=true", () => {
    console.log('re-render')
    api.rerender('04952fb2', render)
  })

}


export default __exports__